/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Pricing_At_CheckoutInputs */

const en_platform_pricing_at_checkout = /** @type {(inputs: Platform_Pricing_At_CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price shown at checkout`)
};

const pl_platform_pricing_at_checkout = /** @type {(inputs: Platform_Pricing_At_CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cena widoczna przy płatności`)
};

/**
* | output |
* | --- |
* | "Price shown at checkout" |
*
* @param {Platform_Pricing_At_CheckoutInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_pricing_at_checkout = /** @type {((inputs?: Platform_Pricing_At_CheckoutInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Pricing_At_CheckoutInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_pricing_at_checkout(inputs)
	return en_platform_pricing_at_checkout(inputs)
});